export default "__VITE_ASSET__4dba295a__"